// The DSP.CAFE wordmark (brand kit, 2026-09-30).
//
// ⚠️ Logo ONLY. "DSP.CAFE" with the coral dot is how the name is drawn as a
// logo — next to the mark on the Welcome/Loading screens and in the top bar.
// Everywhere the name appears in a sentence, a title or an alt text it is
// "DSP Cafe", with a space. The screen-reader label says the same.
//
// The TM (2026-10-22) is kept small, light and faded, set apart from the E
// and lined up with the top of the letters, so it reads as a mark beside the
// logo rather than part of it. Logo only: "DSP Cafe" in text never gets one.
// landing/style.css `.logo-tm` carries the same values.
const tmStyle = {
  fontSize: '0.24em',
  fontWeight: 500,
  letterSpacing: '0.04em',
  opacity: 0.55,
  marginLeft: '0.5em',
  lineHeight: 0,
  verticalAlign: '2.1em',
};

const Wordmark = ({ className = '', style }) => (
  <span
    className={`font-extrabold ${className}`}
    style={{ letterSpacing: '0.05em', ...style }}
    aria-label="DSP Cafe"
    role="img"
  >
    DSP<span style={{ color: 'var(--brand-accent)' }}>.</span>CAFE<span style={tmStyle}>TM</span>
  </span>
);

export default Wordmark;
